// cafe/client/src/components/layout/NotificationItem.jsx
import { Link } from 'react-router-dom';
import { LangLink } from '../common/LangLink';
import { Trans, useTranslation } from 'react-i18next';
import UserAvatar from '../common/UserAvatar';
import {
  formatTimeAgo,
  getNotificationDetails,
} from '../../utils/notificationUtils';

const NotificationItem = ({ notification, onClose }) => {
  const { t } = useTranslation();
  const { sender, createdAt, isRead } = notification;

  // Usamos la función centralizada para obtener los detalles
  const { tKey, tParams, link } = getNotificationDetails(notification);

  return (
    <li className={`${!isRead ? 'bg-primary/5 dark:bg-primary/20' : ''}`}>
      <LangLink
        to={link}
        onClick={onClose}
        className="flex items-start gap-4 p-4 transition-colors hover:bg-neutral-100 dark:hover:bg-neutral-700/50"
      >
        <div className="flex-shrink-0 pt-1 relative">
          <UserAvatar user={sender} size="md" />
          {!isRead && (
            <span className="absolute -top-0.5 -right-0.5 block h-2.5 w-2.5 rounded-full bg-primary ring-2 ring-white dark:ring-neutral-800"></span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-neutral-800 dark:text-neutral-200">
            {/* El componente <Trans> es crucial aquí.
              Interpreta la clave (i18nKey), reemplaza las variables (values)
              y convierte las etiquetas como <bold> en componentes de React.
            */}
            <Trans
              i18nKey={tKey}
              values={tParams}
              components={{ bold: <span className="font-bold" /> }}
            />
          </p>
          <p className="text-xs text-primary dark:text-primary-light mt-1">
            {formatTimeAgo(createdAt, t)}
          </p>
        </div>
      </LangLink>
    </li>
  );
};

export default NotificationItem;
